// Pure helpers for the Org chart tab (kanban b9e6e6af).
import type { OrgNode } from '../../services/roadmapReports';

/** Flatten a chart depth-first to "node + depth" rows (for pickers and counts). */
export function flatten(nodes: OrgNode[], depth = 0): Array<{ node: OrgNode; depth: number }> {
  return nodes.flatMap((n) => [{ node: n, depth }, ...flatten(n.children, depth + 1)]);
}
